import React, { FC, useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from '@wix/wix-i18n-config';
import { TemplateGalleryCard } from '@common/types';
import { useIntersect } from '@wix/experts-common';
import { templatePath } from '@components/Hooks/useRouter';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';
import TemplateLoadedCard from './TemplateLoadedCard';
import TemplateLoadingCard from './TemplateLoadingCard';
import s from './TemplateCard.module.scss';

export interface TemplateCardProps {
  template: TemplateGalleryCard;
  forceRender?: boolean;
  loader?: boolean;
  index: number;
}

const TemplateCard: FC<TemplateCardProps> = ({
  template,
  forceRender,
  loader = false,
  index,
}) => {
  const { t } = useTranslation();

  const [hover, setHover] = useState(false);
  const [focused, setFocused] = useState(false);
  const [ready, setReady] = useState(false || forceRender);
  const [ref, entryElement] = useIntersect({}) as any;
  const { logBiClick } = useTemplatesBi({
    is_mobile: false,
  });

  useEffect(() => {
    if (entryElement.intersectionRatio === 1 && !ready && !loader) {
      setTimeout(() => {
        setReady(true);
      }, 200);
    }
  }, [ready, entryElement]);

  function buildTemplatePageLink() {
    return `${templatePath}/${template.id}`;
  }

  return (
    <div
      aria-labelledby={`template-title-${template.title}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => {
        setHover(false);
        template.media?.animatedPreview && setFocused(false);
      }}
    >
      <a
        data-hook={`template-card-container-${template.id}`}
        href={buildTemplatePageLink()}
        aria-label={t('marketplace.templates-page.view-template-cta')}
        className={s.cardContainer}
        onClick={() => {
          logBiClick({
            click_type: 'View Template',
            click_data: { template_id: template.id },
          });
        }}
      >
        {ready ? (
          <TemplateLoadedCard
            template={template}
            setHover={setHover}
            hover={hover}
            index={index}
          />
        ) : (
          <TemplateLoadingCard ref={ref} />
        )}
      </a>
    </div>
  );
};

export default TemplateCard;
